import { render, staticRenderFns } from "./BadgeInfo.vue?vue&type=template&id=2c6e2a36&scoped=true&"
import script from "./BadgeInfo.vue?vue&type=script&lang=js&"
export * from "./BadgeInfo.vue?vue&type=script&lang=js&"
import style0 from "./BadgeInfo.vue?vue&type=style&index=0&id=2c6e2a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e2a36",
  null
  
)

export default component.exports